import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
// import { Timeline } from 'primereact/timeline';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PropTypes from 'prop-types';
import { formatDatetime, toCamelCaseString } from 'utils/func';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export default function ViewHistoryProposal({ data, visible, setVisible, reverse, width }) {
  const { t } = useTranslation();

  const formatStatus = (value) => {
    const statusColorMapping = {
      create: 'var(--green-500)',
      update: 'var(--orange-500)',
      submit: 'var(--blue-500)',
      approved: 'var(--purple-500)',
      rejected: 'var(--red-500)',
      new: 'var(--blue-500)',
    };

    return (
      <Tag
        style={{ background: statusColorMapping[toCamelCaseString(value.actionType)] }}
        value={t(`proposal.status.${toCamelCaseString(value.actionType)}`)}
        rounded
      />
    );
  };

  const formatCreatedAt = (value) => (
    <small className="text-color-secondary">
      {formatDatetime(value.createdAt, 'HH:mm DD/MM/YYYY')}
    </small>
  );

  return (
    <Dialog
      header={<p className="text-blue-500">{t('proposal.history.title')}</p>}
      visible={visible}
      position="center"
      style={{ width }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      <DataTable
        value={data}
        className="p-datatable-gridlines header-table"
        responsiveLayout="scroll"
        scrollable
        scrollHeight="450px"
        showGridlines
        emptyMessage={t('proposal.history.empty')}
      >
        <Column
          header={t('proposal.history.no')}
          // eslint-disable-next-line react/no-unstable-nested-components
          body={(_, { rowIndex }) => <span>{reverse ? data.length - rowIndex : rowIndex + 1}</span>}
          style={{ width: '50px', textAlign: 'center' }}
        />
        <Column
          field="fullname"
          header={t('proposal.history.owner')}
          style={{ minWidth: '12rem', textAlign: 'left' }}
        />
        <Column
          field="note"
          header={t('proposal.history.note')}
          style={{ minWidth: '20rem', textAlign: 'left' }}
          // eslint-disable-next-line react/no-unstable-nested-components
          body={(value) => (
            <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
              {value.note}
            </span>
          )}
        />
        <Column
          field="createdAt"
          header={t('proposal.history.time')}
          body={formatCreatedAt}
          style={{ minWidth: '5rem', textAlign: 'left' }}
        />
        <Column
          field="actionType"
          header={t('proposal.history.status')}
          body={formatStatus}
          style={{ minWidth: '9rem', textAlign: 'center' }}
        />
      </DataTable>
    </Dialog>
  );
}

ViewHistoryProposal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  reverse: PropTypes.bool,
  width: PropTypes.string,
};

ViewHistoryProposal.defaultProps = {
  reverse: false,
  width: '900px',
};
